import { Button } from '../Button/Button';

export interface ErrorStateProps {
  message: string;
  /** Sem ele, o estado é só informativo. */
  onRetry?: () => void;
}

/** Bloco de erro de carregamento de uma tela ou painel, com "Tentar de novo". */
export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div
      role="alert"
      className="border-(--color-border) bg-(--color-bg-primary) rounded-xl border p-8 text-center"
    >
      <p className="text-(--color-text-secondary) text-sm">{message}</p>
      {onRetry && (
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="mt-4"
          onClick={onRetry}
        >
          Tentar de novo
        </Button>
      )}
    </div>
  );
}
